import React from "react";
import { render } from "react-dom";

import App from "./app";

import "./styles/styles.scss";

render(
  <App />,
  document.getElementById("app")
);
